import { NavigationCard } from "@/components/navigation-card";

export function ExploreScriptsCard() {
  return (
    <NavigationCard
      title="Explore Scripts"
      splash="https://images.unsplash.com/photo-1556808752-77f2fe75360b?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w1NDM2NzN8MHwxfHNlYXJjaHw0Mnx8c2NyaXB0fGVufDB8MHx8fDE3NDU1MjI4Mjh8MA&ixlib=rb-4.0.3&q=80&w=200"
      description="Explore all the custom scripts made by the community."
      to="/explore-scripts"
    />
  );
}
